module.exports = __webpack_public_path__ + "img/winning_at_new_product.7d6551ae.jpg";